import React, {useEffect, useRef} from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {convertToString, sortById} from "../../util/functions";
import SelectFormVirtualize from "./SelectFormVirtualize";
import {isEmpty, isObject} from "../../util/is";


const NestedSelectVirtualizeForm = ({disabled = false, keyFatherValue, keyIdentificador, label,
                             required , className, executeFunction, options, customControl, showId = true, customError, isMulti = false, closeMenuOnSelect = true}) => {

    const { control, setValue, formState: { errors } } = useFormContext();


    const nestedValue = useWatch({
        control,
        name: keyFatherValue,
    });


    const ref = useRef(nestedValue);

    useEffect(() => {
        if(convertToString(ref.current) !== convertToString(nestedValue)){
            setValue(keyIdentificador, null);
        }
    }, [nestedValue, ref])

    return(
        <SelectFormVirtualize  inputProps={{control: isEmpty(customControl) ? control : customControl}} disabled={disabled} identificador={keyIdentificador}
                               label={label} options={keyFatherValue === keyIdentificador ? options : options?.filter((item) => convertToString(item?.padre) === (isObject(nestedValue) ? convertToString(nestedValue?.id) : convertToString(nestedValue)))?.sort(sortById)}
                               required={required}  className={className} customError={customError} showId={showId} closeMenuOnSelect={closeMenuOnSelect} isMulti={isMulti}/>
    )

}

export default NestedSelectVirtualizeForm;
